<template>
  <div id="puzzle-solution">
    <vue-markdown>The image depicts a [Ghost Leg](https://en.wikipedia.org/wiki/Ghost_Leg), a type of lottery used to pair two sets of items. Each horizontal "leg" swaps two adjacent items, similar to the bubble sort algorithm. Following the numbers down or the letters up will produce the assignment:
    </vue-markdown>

<div class="flex">
  <div>
    <table class="table">
    <thead>
    <tr>
    <th style="text-align:center">number</th>
    <th style="text-align:center">letter</th>
    </tr>
    </thead>
    <tbody>
    <tr>
    <td style="text-align:center">1</td>
    <td style="text-align:center">D</td>
    </tr>
    <tr>
    <td style="text-align:center">2</td>
    <td style="text-align:center">E</td>
    </tr>
    <tr>
    <td style="text-align:center">3</td>
    <td style="text-align:center">A</td>
    </tr>
    <tr>
    <td style="text-align:center">4</td>
    <td style="text-align:center">F</td>
    </tr>
    <tr>
    <td style="text-align:center">·</td>
    <td style="text-align:center">B</td>
    </tr>
    <tr>
    <td style="text-align:center">·</td>
    <td style="text-align:center">C</td>
    </tr>
    </tbody>
    </table>

  </div>
  <div>
    <img src="@/assets/img/soln-phantom.png">

  </div>
</div>
    <vue-markdown>
Ignoring the dots, we can read the answer from the letters numbered 1-4: **DEAF**.
    </vue-markdown>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'

export default {
  components: {
    VueMarkdown
  }  
}
</script>

<style lang="scss" scoped>
  img {
    max-height: 400px;
  }
</style>